import { useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-image-gallery/styles/css/image-gallery.css";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Loader from "../../Components/Common/Loader";
import {
  Card,
  Col,
  Container,
  Row,
  Input,
  Label,
  FormFeedback,
  Form,
} from "reactstrap";

import { Link, useHistory, useParams } from "react-router-dom";

//formik
import { useFormik } from "formik";
import * as Yup from "yup";

// Import React FilePond
import { registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

import { useInnovation, useUpdateInnovation } from "../../hooks/useInnovations";
import { normalizeBackendFileUrl } from "../../utils/backendApi";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const InnovationsUpdate = (props) => {
  document.title = "Modifier un article";
  const updateMutation = useUpdateInnovation();

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileIsEdit, setFileIsEdit] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    setFileIsEdit(true);
  };

  const history = useHistory();
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const { id } = useParams();
  const innovationQ = useInnovation(id);

  const selectAticle = innovationQ.data || {};

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectAticle.id,
      innovation_pic: selectAticle.innovation_pic,
      label: selectAticle.label,
      description: selectAticle.description,
    },
    validationSchema: Yup.object({
      label: Yup.string().required(props.t("Ce champ est requis")),
      description: Yup.string().required(props.t("Ce champ est requis")),
    }),
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("id", selectAticle.id);
      formData.append("label", values.label);
      formData.append("description", values.description);
      selectedFile && formData.append("innovation_pic", selectedFile);

      try {
        await updateMutation.mutateAsync({ id, payload: formData });
        validation.resetForm();
        history.push("/innovations");
      } catch (_) {
        // handled by toast
      }
    },
  });

  if (innovationQ.isLoading) return <Loader />;
  if (innovationQ.isError)
    return <Loader error={innovationQ.error?.message || "Erreur"} />;

  const innovationImageUrl = normalizeBackendFileUrl(
    selectAticle.innovation_pic
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={props.t("Modification d'innovations")}
          pageTitle={props.t("Innovations")}
        />
        <Form
          encType="multipart/form-data"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <Row>
            <Col lg={12}>
              <Card className="p-4">
                <div className="mb-3">
                  <Label className="form-label" htmlFor="photo">
                    {props.t("IMAGE")}{" "}
                    <span style={{ color: "red" }}>
                      * Tous les champs sont obligatoires
                    </span>
                  </Label>
                  <div>
                    <input
                      type="file"
                      className="form-control"
                      name="innovation_pic"
                      accept="image/*"
                      capture="file"
                      onChange={handleFileChange}
                    />
                    <br />

                    {selectedFile && fileIsEdit ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={URL.createObjectURL(selectedFile)}
                          style={{ maxWidth: "50%" }}
                          alt={`Thumbnail`}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {selectAticle && (
                          <img
                            src={innovationImageUrl}
                            style={{ maxWidth: "50%" }}
                            alt={`Thumbnail`}
                          />
                        )}
                      </div>
                    )}
                  </div>
                  {validation.errors.innovation_pic &&
                  validation.touched.innovation_pic ? (
                    <FormFeedback type="invalid">
                      {props.t(validation.errors.innovation_pic)}
                    </FormFeedback>
                  ) : null}
                  <br />
                </div>
                <div className="mb-3">
                  <Label className="form-label" htmlFor="label">
                    {props.t("TITRE")} <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Input
                    type="text"
                    className="form"
                    style={{ fontWeight: "bold", textTransform: "uppercase" }}
                    name="label"
                    value={validation.values.label}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    invalid={
                      validation.errors.label && validation.touched.label
                        ? true
                        : false
                    }
                  />
                  {validation.errors.label && validation.touched.label ? (
                    <FormFeedback type="invalid">
                      {props.t(validation.errors.label)}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label className="form-label" htmlFor="description">
                    {" "}
                    {props.t("DESCRIPTION")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={validation.values.description}
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    rows="10"
                    cols="20"
                  />
                  {validation.errors.description &&
                  validation.touched.description ? (
                    <FormFeedback type="invalid">
                      {props.t(validation.errors.description)}
                    </FormFeedback>
                  ) : null}
                </div>
              </Card>
              <div className="text-end mb-3">
                <Link to="/innovations" className="btn btn-primary me-2">
                  {props.t("Retour")}
                </Link>
                <button type="submit" className="btn btn-warning m-2">
                  {props.t("Modifier")}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};
InnovationsUpdate.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(InnovationsUpdate));
